'use strict';

angular.module('shop').component('checkZipcode', {
	templateUrl: 'component/check-zipcode.html',
	controller: function ($rootScope, ShopService, ZipCodeService, Toast) {
		var self = this;

		self.$onInit = function() {
			self.input = {};
			self.showOverlay = false;
			self.loading = false;
			self.validZipcode = false;

			self.cart = ShopService.getCart();

			if (self.cart && self.cart.zipcode) {
				self.zipcode = self.cart.zipcode;
				self.validZipcode = self.cart.validZipcode;
				self.input.zipcode = self.zipcode;
			}
		};

		self.check = function(zipcode) {
			if (self.loading || !zipcode) return;

			self.loading = true;
			self.zipcode = zipcode;
			self.validZipcode = false;

			self.cart = ShopService.getCart();

			if (!self.cart) {
				self.cart = ShopService.createCart();
			}

			self.cart.zipcode = zipcode;
			self.cart.validZipcode = false;

			ZipCodeService.check(zipcode).then(function (response) {
				if (response.status === 1 && response.zipcodeStatus === 1) {
					self.validZipcode = true;

					self.cart.city = response.city || '';
					self.cart.validZipcode = true;
					ShopService.setCart(self.cart);

					if (self.product) {
						ShopService.addToCart(self.product);
						self.product = undefined;
					}
					
					var msg = 'Yes, vi kan leverera hem till dig på postnummer ' + zipcode + ' ' + response.city;
					Toast.successContent('<i class="mk-icon mk-icon-share mk-icon-x5"></i><h1 class="mt-md">' + msg + '</h1>');

					self.showOverlay = false;
				} else {
					ShopService.setCart(self.cart);
				}
				self.loading = false;
			}, function() {
				ShopService.setCart(self.cart);
				self.loading = false;
			});
		};

		self.close = function() {
			self.showOverlay = false;
			self.product = undefined;
		};

		$rootScope.$on('shop-zipcode.check', function(event, product) {
			self.product = product;
			self.showOverlay = true;
		});
	},
});
